import { cloneDeep } from 'lodash-es';
import { generateObjectHash } from './object-hash';

export class CacheController {
  private cache!: Map<string, any>;

  constructor(public enabled: boolean) {
    this.cache = new Map();
  }

  public get(key: string, context: any): any {
    if (!this.enabled) return undefined;
    return this.cache.get(this.getCacheName(key, context));
  }

  public set(key: string, context: any, value: any): void {
    if (!this.enabled) return undefined;
    this.cache.set(this.getCacheName(key, context), value);
  }

  public has(key: string, context: any): boolean {
    return this.cache.has(this.getCacheName(key, context));
  }

  public clear(): void {
    this.cache.clear();
  }

  public generateContext(constext: any): any {
    try {
      return cloneDeep(constext);
    } catch (err) {
      console.log('error in cache generateContext', err);
      return constext;
    }
  }

  public getCacheName(key: string, context: any): string {
    const hash = generateObjectHash(context);
    return key + '_' + hash;
  }
}
